var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c(
        "div",
        {
          staticClass: "fh lc",
          staticStyle: {
            width: "630px",
            height: "100px",
            "margin-bottom": "10px",
            background: "#ffffff",
            "border-style": "solid",
            "border-width": "1px",
            border: "1px solid #dddddd",
            "box-shadow": "1px 1px 2px #dddddd"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "fh cc",
              staticStyle: { width: "15%", height: "100%" }
            },
            [
              _c("img", {
                staticStyle: {
                  width: "90%",
                  height: "90%",
                  "object-fit": "contain"
                },
                attrs: { id: "imagenProducto", src: _vm.imagenProducto }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fv lt",
              staticStyle: { width: "65%", height: "100%" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fh lt",
                  staticStyle: {
                    width: "100%",
                    height: "20%",
                    "margin-left": "5px",
                    "margin-top": "3px",
                    "font-size": "14px",
                    "font-weight": "500",
                    color: "#656E76"
                  }
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.item.Nombre) + "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh lt",
                  staticStyle: {
                    width: "100%",
                    height: "50%",
                    "margin-left": "5px",
                    "margin-top": "3px",
                    "font-size": "12px",
                    color: "#656E76"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.item.Observacion) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "fv lc", staticStyle: { height: "30%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh lt",
                      staticStyle: {
                        width: "100%",
                        "font-weight": "bold",
                        color: "#656E76",
                        "margin-left": "5px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: { "font-size": "10px", width: "120px" }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.precioHabitualLabel) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: {
                            "font-size": "11px",
                            width: "120px",
                            "text-decoration": "line-through"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.moneyLabelPrecioHabitual) +
                              _vm._s(
                                _vm._f("formatMoney")(_vm.getPrecioHabitual)
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh rt",
                          staticStyle: { "font-size": "10px", width: "70px" }
                        },
                        [
                          _vm._v(
                            "\n                    Valido desde:\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: {
                            "font-size": "10px",
                            "margin-left": "10px"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getFechaDesde) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lt",
                      staticStyle: {
                        width: "100%",
                        "font-weight": "bold",
                        color: "#656E76",
                        "margin-left": "5px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: { "font-size": "10px", width: "120px" }
                        },
                        [
                          _vm._v(
                            "\n                    Precio Promocional:\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: { "font-size": "11px", width: "120px" }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.moneyLabelPrecioPromocional) +
                              _vm._s(
                                _vm._f("formatMoney")(_vm.getPrecioPromocional)
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh rt",
                          staticStyle: { "font-size": "10px", width: "70px" }
                        },
                        [
                          _vm._v(
                            "\n                    hasta:\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: {
                            "font-size": "10px",
                            "margin-left": "10px"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getFechaHasta) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fv cc",
              staticStyle: { width: "20%", height: "100%" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDescuentos,
                      expression: "showDescuentos"
                    }
                  ],
                  staticClass: "fh rt",
                  staticStyle: {
                    "font-size": "10px",
                    background: "#F7A541",
                    color: "#ffffff",
                    "border-radius": "50%",
                    padding: "5px",
                    "margin-bottom": "3px"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.porcentajeDescuento) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                { attrs: { id: "btnAgregar" }, on: { click: _vm.btnAgregar } },
                [_vm._v("AGREGAR A PEDIDO")]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47eca532", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47eca532","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/itemPromociones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-47eca532","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/itemPromociones.vue
// module chunks = 0